import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var PatientDetailsRes;
export const PatientDetailsTodo = createAsyncThunk('PatientDetails', async (id) => {

    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + `admin/patient/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token')},
            params:{
                "company_id":localStorage.getItem('companyId')
            },
        })
        return PatientDetailsRes = res.data

    } catch (error) {
        return PatientDetailsRes = error.response.data
    }
});

const PatientDetailsSlice = createSlice({
    name: 'PatientDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(PatientDetailsTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(PatientDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default PatientDetailsSlice.reducer; 